import _isEqual from 'lodash/isEqual'

// TODO: put this in storybook because both presenter and audience are using the same function
// For now, this file has to be separated from the other utils because
// Jest is complaining when importing src/util file

// deterministically suffer an array with seed
// meaning: the same seed will always result in the same array

function hashStringToNumber(str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char // Shift and sum
    hash |= 0 // Convert to 32-bit integer
  }
  return Math.abs(hash) // Return a positive number
}

const shuffleArrayWithSeed = (arr, seed) => {
  if (arr.length <= 1) return arr
  let result = []
  const newArr = [...arr]

  if (typeof seed === 'string') {
    seed = hashStringToNumber(seed)
  }

  for (let i = 0; i < arr.length; i++) {
    const index = seed % newArr.length
    result.push(newArr[index])
    newArr.splice(index, 1)
  }

  while (_isEqual(result, arr)) {
    result = shuffleArrayWithSeed(arr, seed + 1)
  }
  return result
}

export default shuffleArrayWithSeed
